/**
 * getUserMemberInfo 返回的 vipLevel 与展示文案、样式类
 * -1 普通 · 1 VIP月卡 · 2 VIP年卡 · 3 SVIP年卡
 */
export function vipLevelToLabel(level) {
  const n = Number(level)
  if (Number.isNaN(n)) return '普通会员'
  if (n === -1) return '普通会员'
  if (n === 1) return 'VIP月卡会员'
  if (n === 2) return 'VIP年卡会员'
  if (n === 3) return 'SVIP年卡会员'
  return '普通会员'
}

/** 用于徽章配色：normal | vip | svip */
export function vipLevelBadgeKind(level) {
  const n = Number(level)
  if (Number.isNaN(n) || n === -1) return 'normal'
  if (n === 3) return 'svip'
  if (n === 1 || n === 2) return 'vip'
  return 'normal'
}
